export default "__VITE_ASSET__SBofkRiI__"